import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExportFacade, ExportIdentificationStatus, ExportMetadata } from '@planone/bau365/data-access-export';
import { KeycloakService } from 'keycloak-angular';
import { filter, Observable, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'bau365-page-export',
  templateUrl: './page-export.component.html',
  styleUrls: ['./page-export.component.scss'],
})
export class PageExportComponent implements OnInit, OnDestroy {
  meta$: Observable<ExportMetadata | undefined>;
  status$: Observable<ExportIdentificationStatus>;
  private unsubscribe$: Subject<void> = new Subject<void>();

  metaNamePlaceholder: string = $localize`:@@featureExport-meta-namePlacholder:Kein Name`;

  ngOnInit(): void {
    this.exportFacade.identifyMeta({
      documentId: this.route.snapshot.params['document_id'],
    });

    this.meta$
      .pipe(
        filter((meta) => !meta?.name),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => {
        this.metaNamePlaceholder = new Date().toJSON().slice(0, 10) + '_unknown';
        const instance = this.keycloakService.getKeycloakInstance();
        const token = instance.tokenParsed;

        if (token) {
          const initals = token['given_name'].charAt(0).toUpperCase() + token['family_name'].charAt(0).toUpperCase();
          this.metaNamePlaceholder += '_' + initals;
        }

        this.metaNamePlaceholder = this.metaNamePlaceholder + '.xlsx';
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  constructor(
    private route: ActivatedRoute,
    private exportFacade: ExportFacade,
    private keycloakService: KeycloakService
  ) {
    this.meta$ = exportFacade.meta$;
    this.status$ = exportFacade.metaStatus$;
  }

  download(fileName?: string) {
    this.exportFacade.download({
      list: 'download',
      exportTypeName: 'unknown',
      to: 'download',
      documentId: this.route.snapshot.params['document_id'],
      fileName: fileName,
    });
  }
}
